module.exports = __webpack_public_path__ + "static/img/noClass.62b5a971.png";